import config from '../config';
import { PzptApiOptions } from './PzptApiOptions';
import { PzptApi } from './createPzptRequest';
import { BaseResponse, ImageData } from './shared';

interface QueryImagListByGroupIdRequest {
  groupCode: string;
}

interface QueryImageListByGroupIdResponse extends BaseResponse {
  data: Array<ImageData>;
}

/**
 * 根据分组编码查询素材
 * @param params
 * @returns
 */
export async function queryImageListByGroupId(request: QueryImagListByGroupIdRequest, options?: PzptApiOptions) {
  const url = config.pzptLink + '/api/contest/getGroupItem';
  return PzptApi.fetch<QueryImageListByGroupIdResponse>(url, request, options);
}
